import React from "react";
import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik } from "formik";
import { Grid, Typography, Card, TableContainer, Table, TableRow, TableCell, TableBody, Autocomplete, FormControlLabel, Checkbox } from "@mui/material";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import api from "../../../components/services/api";
import withReactContent from "sweetalert2-react-content";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";

import AddIcon from "@mui/icons-material/Add";

import Select from "@mui/material/Select";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles({
    customOutline: {
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "red",
        },
    },
});
export default function AddLocation() {
    const classes = useStyles();
    const [MasterCost, setMasterCost] = useState([])

    const history = useHistory();
    const [locationData, setLocationData] = useState([]);
    const [countryData, setCountryData] = useState([]);
    const [pol, setPol] = useState();
    const [country, setCountry] = useState("");
    const EmpId = localStorage.getItem("EmpId");
    const [rows, setRows] = useState([]);
    const [currency, setCurrency] = useState([]);

    function addRow() {
        const newRow = {
            id: rows?.slice(-1)[0]?.id ? rows?.slice(-1)[0]?.id + 1 : 1,
            CostId: "",
            CostPrice: 0,
            CurrencyId: "",
            CostPerContainer: true
        };

        setRows([...rows, newRow]);
    }
    const deletehand = (i) => {

        const data = rows?.filter((e, id) => i !== id);
        setRows(data);
    };
    const FetchCountry = async () => {
        try {
            const res = await api.get(
                "api/master/country"
            );
            setCountryData(res.data.data);
            // console.log(data.data.data);
        } catch (e) {
            console.log(e);
        }
    };
    const getMasterCost = async () => {
        try {
            const res = await api.get(`/api/master/cost/Sale%20Order%20Cost`);
            setMasterCost(res?.data);

            //   setLog_data_length(3);
        } catch (e) {
            console.log(e);
        }
    };
    const getCurrency = async () => {
        try {
            const res = await api.get(`api/master/currency`);
            setCurrency(res?.data);

            //   setLog_data_length(3);
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        FetchCountry();
        getMasterCost()
        getCurrency()
    }, []);
    return (
        <div>
            <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
                <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
                    ตำแหน่ง
                </h6>

                <Grid container alignItems="center" spacing={1}>
                    <Grid item xs>
                        <Typography
                            className="textcolordarkblue"
                            variant="h5"
                            component="h1"
                        >
                            Location
                        </Typography>
                    </Grid>
                    <Grid item sx={{ display: "flex", flexDirection: "row" }}>
                        <Typography className="textcolorBule">Setting</Typography>
                        <Typography>
                            <span>&nbsp;</span> / Create Location
                        </Typography>
                    </Grid>
                </Grid>

                <Formik
                    initialValues={{
                        CountryId: "",
                        LocationName: "",
                        LocationCode: "",
                        VoyCode: "",
                        MAC5ShipCode: "",
                        MAC5TrainCode: "",
                        MAC5TruckCode: "",
                        Status: true
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                        setTimeout(() => {
                            const body = {
                                CountryId: values?.CountryId,
                                LocationName: values?.LocationName,
                                LocationCode: values?.LocationCode,
                                VoyCode: values?.VoyCode,
                                MAC5ShipCode: values?.MAC5ShipCode,
                                MAC5TrainCode: values?.MAC5TrainCode,
                                MAC5TruckCode: values?.MAC5TruckCode,
                                LocationCostDetails: rows
                            }

                            api
                                .post("api/location/create", body)
                                .then((respose) => {
                                    Swal.fire({
                                        text: `${respose.meta.message}`,
                                        icon: 'success',
                                        confirmButtonColor: '#3085d6',
                                        confirmButtonText: 'OK'
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            history.push("/Setting/location");

                                        }
                                    })
                                })
                                .catch((err) => {
                                    console.log(err);
                                });

                            setSubmitting(false);
                        }, 400);
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        /* and other goodies */
                    }) => (
                        <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
                            <Grid container>
                                <Grid item xs={12} md={12}>
                                    <FormControl fullWidth required classes={{ root: !values.CountryId ? classes.customOutline : null }}
                                    >
                                        <InputLabel sx={{ top: '10px' }}>Country</InputLabel>
                                        <Select
                                            value={values.CountryId}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            label="Country"
                                            name='CountryId'
                                            style={{
                                                width: "50%",
                                                marginTop: "10px",
                                                marginBottom: "10px",
                                            }}
                                        >
                                            {countryData?.map((option) => {
                                                return (
                                                    <MenuItem
                                                        key={option?.CountryId}
                                                        value={option?.CountryId}
                                                    >
                                                        {option?.CountryName}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={12} sx={{ marginTop: '10px' }}>
                                    <TextField
                                        name="LocationName"
                                        label="Location Name"
                                        variant="outlined"
                                        required
                                        placeholder="Location Name"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        style={{ width: "50%", marginRight: 5 }}
                                        InputLabelProps={{ shrink: true }}
                                        value={values.LocationName}
                                        classes={{ root: !values.LocationName ? classes.customOutline : null }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={12} sx={{ marginTop: '10px' }}>
                                    <TextField
                                        name="LocationCode"
                                        label="Location Code"
                                        variant="outlined"
                                        required
                                        placeholder="Location Code"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        style={{ width: "50%", marginRight: 5 }}
                                        InputLabelProps={{ shrink: true }}
                                        value={values.LocationCode}
                                        classes={{ root: !values.LocationCode ? classes.customOutline : null }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={12} sx={{ marginTop: '10px', marginBottom: '20px' }}>
                                    <TextField
                                        name="VoyCode"
                                        label="Voy Code"
                                        variant="outlined"
                                        required
                                        placeholder="Voy Code"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        style={{ width: "50%", marginRight: 5 }}
                                        InputLabelProps={{ shrink: true }}
                                        value={values.VoyCode}
                                        classes={{ root: !values.VoyCode ? classes.customOutline : null }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={12} sx={{ marginTop: '10px', marginBottom: '20px' }}>
                                    <TextField
                                        name="MAC5ShipCode"
                                        label="MAC-5 Ship Code"
                                        variant="outlined"
                                        required
                                        placeholder="MAC-5 Ship Code"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        style={{ width: "50%", marginRight: 5 }}
                                        InputLabelProps={{ shrink: true }}
                                        value={values.MAC5ShipCode}
                                    />
                                </Grid>
                                <Grid item xs={12} md={12} sx={{ marginTop: '10px', marginBottom: '20px' }}>
                                    <TextField
                                        name="MAC5TrainCode"
                                        label="MAC-5 Train Code"
                                        variant="outlined"
                                        required
                                        placeholder="MAC-5 Train Code"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        style={{ width: "50%", marginRight: 5 }}
                                        InputLabelProps={{ shrink: true }}
                                        value={values.MAC5TrainCode}
                                    />
                                </Grid>
                                <Grid item xs={12} md={12} sx={{ marginTop: '10px', marginBottom: '20px' }}>
                                    <TextField
                                        name="MAC5TruckCode"
                                        label="MAC-5 Truck Code"
                                        variant="outlined"
                                        required
                                        placeholder="MAC-5 Truck Code"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        style={{ width: "50%", marginRight: 5 }}
                                        InputLabelProps={{ shrink: true }}
                                        value={values.MAC5TruckCode}
                                    />
                                </Grid>
                            </Grid>
                            <Button
                                type="button"
                                variant="contained"
                                // disabled={costType ? false : true}
                                style={{
                                    background: "#80c340",
                                    borderColor: "#80c340",
                                    marginTop: "10px",
                                }}
                                onClick={addRow}
                            >
                                <AddIcon /> Add
                            </Button>
                            <TableContainer sx={{ marginTop: 2, marginBottom: 2 }}>
                                <Table stickyHeader>
                                    <TableRow>
                                        <TableCell align="center" width="5%">#</TableCell>
                                        <TableCell align="center" width="15%">Charge</TableCell>
                                        <TableCell align="center" width="10%">Quantity</TableCell>
                                        <TableCell align="center" width="15%">Price</TableCell>
                                        <TableCell align="center" width="10%">Currency</TableCell>

                                        {/* <TableCell align="center" width="15%">TaxTotal</TableCell> */}
                                        <TableCell align="center" width="10%"></TableCell>
                                    </TableRow>
                                    {rows?.map((data, index) => {
                                        return (
                                            <TableBody key={index}>
                                                <TableCell align="center">{index + 1}</TableCell>
                                                <TableCell align="center">
                                                    {/* <FormControl fullWidth>
                        <InputLabel>Charge</InputLabel>
                        <Select
                          label="Charge"
                          value={data?.CostId || ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => {
                            const io = rows?.map((v) => {
                              v.CostId =
                                v?.id === data?.id ? e.target.value : v?.CostId;
                              v.Cost =
                                v?.id === data?.id ? MasterCost.find(x => x?.CostId === e.target.value) : v?.Cost;
                              v.CostPrice =
                                v?.id === data?.id ? MasterCost.find(x => x?.CostId === e.target.value)?.CostPrice : +v?.CostPrice;
                              v.CurrencyId =
                                v?.id === data?.id ? MasterCost.find(x => x?.CostId === e.target.value)?.CurrencyId : v?.CurrencyId;

                              return v;
                            });

                            setRows([...io]);
                          }}
                        >
                          {MasterCost?.map((x) =>
                            <MenuItem value={x?.CostId}>{x?.CostName}</MenuItem>
                          )}
                        </Select>
                      </FormControl> */}
                                                    <Autocomplete
                                                        // freeSolo
                                                        fullWidth
                                                        options={MasterCost}
                                                        getOptionLabel={(option) => option?.CostName}
                                                        // renderOption={(props, option) => (
                                                        //   <Box component="li" {...props} key={option.EmpNo}>
                                                        //     {option?.firstname} {option?.lastname}</Box>
                                                        // )}

                                                        id="controlled-demo"
                                                        value={data?.Cost}
                                                        onChange={(event, newValue) => {

                                                            const io = rows?.map((v) => {
                                                                v.Cost =
                                                                    v?.id === data?.id ? newValue : v?.Cost;
                                                                v.CostId =
                                                                    v?.id === data?.id ? newValue?.CostId : v?.CostId;
                                                                v.Cost =
                                                                    v?.id === data?.id ? MasterCost.find(x => x?.CostId === newValue?.CostId) : v?.Cost;
                                                                v.CostPrice =
                                                                    v?.id === data?.id ? MasterCost.find(x => x?.CostId === newValue?.CostId)?.CostPrice : +v?.CostPrice;
                                                                v.CurrencyId =
                                                                    v?.id === data?.id ? MasterCost.find(x => x?.CostId === newValue?.CostId)?.CurrencyId : v?.CurrencyId;

                                                                return v;
                                                            });

                                                            setRows([...io]);
                                                        }}

                                                        selectOnFocus
                                                        clearOnBlur
                                                        handleHomeEndKeys
                                                        renderInput={(params) => (
                                                            <TextField {...params} label="Charge" />
                                                        )}
                                                    />
                                                </TableCell>


                                                <TableCell align="center">


                                                    <FormControlLabel control={<Checkbox
                                                        checked={
                                                            data?.CostPerContainer || ''
                                                        }

                                                        onChange={(e) => {
                                                            const io = rows?.map((v) => {
                                                                v.CostPerContainer =
                                                                    v?.id === data?.id ? e.target.checked : v?.CostPerContainer;

                                                                return v;
                                                            });

                                                            setRows([...io]);
                                                        }} />} label="per CNTR" />

                                                </TableCell>
                                                <TableCell align="center">
                                                    <TextField
                                                        label="Price"
                                                        value={data?.CostPrice || ''}
                                                        type='number'
                                                        onChange={(e) => {
                                                            const io = rows?.map((v) => {
                                                                v.CostPrice =
                                                                    v?.id === data?.id ? +e.target.value : +v?.CostPrice;

                                                                return v;
                                                            });

                                                            setRows([...io]);
                                                        }}
                                                    />
                                                </TableCell>
                                                <TableCell align="center">
                                                    <FormControl fullWidth>
                                                        <InputLabel>Currency</InputLabel>
                                                        <Select
                                                            label="Currency"
                                                            value={data?.CurrencyId || ''}
                                                            InputLabelProps={{ shrink: true }}
                                                            onChange={(e) => {
                                                                const io = rows?.map((v) => {
                                                                    v.CurrencyId = v?.id === data?.id ? e.target.value : v?.CurrencyId;

                                                                    return v;
                                                                });

                                                                setRows([...io]);
                                                            }}
                                                        >
                                                            {currency?.map((x) =>
                                                                <MenuItem value={x?.CurrencyId}>{x?.CurrencyCode}</MenuItem>

                                                            )}
                                                        </Select>
                                                    </FormControl>
                                                </TableCell>




                                                <TableCell align="center">
                                                    <Button
                                                        type="button"
                                                        variant="outlined"
                                                        style={{
                                                            color: "#80c340",
                                                            borderColor: "#80c340",
                                                        }}
                                                        onClick={() => deletehand(index)}
                                                    >
                                                        Delete
                                                    </Button>
                                                </TableCell>
                                            </TableBody>
                                        );
                                    })}

                                </Table>
                            </TableContainer>
                            <Button
                                type="button"
                                variant="outlined"
                                style={{
                                    color: "#80c340",
                                    borderColor: "#80c340",
                                    marginRight: "10px",
                                }}
                                onClick={history.goBack}
                            >
                                back
                            </Button>
                            <Button
                                type="submit"
                                variant="contained"
                                style={{
                                    background: "#80c340",
                                    borderColor: "#80c340",
                                    marginRight: "10px",
                                }}
                                disabled={isSubmitting}
                            >
                                {isSubmitting && <CircularProgress size={22} />}
                                {!isSubmitting && "SAVE"}
                            </Button>
                        </form>
                    )}
                </Formik>
            </Card>
        </div>
    )
}
